import { computed } from 'vue';
import { searchUsers, User as UserApi } from '@infuse/api/e-connector/user';
import { mapToDomain } from '@infuse/e-connector/user/domain';
import { usePageableResource } from '@infuse/e-connector/shared/queries';

export const useUsers = (pageSize = 20) => {
  const SEARCHABLE_FIELDS = ['name'];

  const query = usePageableResource<UserApi>(searchUsers, {
    queryKey: 'users',
    searchableFields: SEARCHABLE_FIELDS,
    pageSize
  });

  const users = computed(
    () => query.data.value?.pages.flatMap((page) => page.content.map((u) => mapToDomain(u))) || []
  );

  return {
    ...query,
    users
  };
};
